<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container text-center" >
                <template #default>   <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-lg-12" >
                <template #default>«ارسال کلیه سفارش‌ها طی ۲ تا ۵ روز کاری پس از ثبت و تأیید نهایی انجام خواهد شد.»   </template>
                </m-Alert-1><m-modal-501 v-bind='{...{"modalButtonText":"\u0631\u0627\u0647\u0646\u0645\u0627\u06cc \u0627\u0646\u062a\u062e\u0627\u0628 \u0631\u0648\u0634 \u0627\u0631\u0633\u0627\u0644","isVisible":true,"customModalId":null,"closeModalFromUser":true,"showOnEnter":false,"showCloseButton":false},...{}}' :style='""' class="shopping-cart-modal " >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="text-center mt-5 h5" >
                <template #default>📦 راهنمای انتخاب روش ارسال
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-right" >
                <template #default>برای ارسال سفارش، ۳ روش در دسترس شماست:
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-right font-weight-bold" >
                <template #default> پست – پس‌کرایه: هزینه ارسال هنگام تحویل مرسوله توسط مشتری پرداخت می‌شود.
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-right font-weight-bold" >
                <template #default> *تیپاکس – پس‌کرایه: معمولاً سریع‌تر و مطمئن‌تر از پست است، اما هزینه ارسال بیشتری دارد.
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-right font-weight-bold" >
                <template #default> *پست – پرداخت آنلاین: هزینه ارسال توسط سایت به‌صورت خودکار محاسبه و هنگام ثبت سفارش دریافت می‌شود.
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-right h5" >
                <template #default>⚠️ توجه:   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-right font-weight-bold" >
                <template #default> سفارش‌های حاوی *مایعات فقط از طریق تیپاکس ارسال می‌شوند.
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-right font-weight-bold" >
                <template #default> سفارش‌های *زیر ۱۰۰ هزار تومان امکان ارسال به‌صورت پس‌کرایه ندارند و فقط از طریق پست با پرداخت هزینه ارسال هنگام ثبت سفارش ارسال خواهند شد.
   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="text-right font-weight-bold h5" >
                <template #default>💡 پیشنهاد ما: اگر سرعت و اطمینان بیشتر برایتان اهمیت دارد، تیپاکس* را انتخاب کنید.   </template>
                </m-p></template>
                </m-modal-501></template>
                </m-div><m-un-authenticated-shopping-cart2 v-bind='{...{"EmptyCartImage":null,"instagramProp":false,"hideAddressDescription":true,"hideSignupButton":true,"presenterProp":false,"order_description_prop":true,"postal_code_prop":true,"codeMeliProp":false,"gradeProp":false,"orientationProp":false,"schoolNameProp":false,"classNameProp":false,"birthdayProp":false,"motherJobProp":false,"fatherJobProp":false,"registerRequestProp":false,"gradeSelectProp":false,"roundTripServiceProp":false,"shiftProp":false,"deliveryNewAddressProp":true,"deliveryDefaultAddressProp":false,"hideRefreshShoppingCartButton":true,"defaultGate":"zarinpal","activeShoppingCartForm":false,"addressRequired":true,"setUnauthenticatedShoppingCartFromLoginUser":false,"advanceDescriptionInputs":"","advanceDescription":false,"showProductListProp":true,"orderDescriptionValueProp":"","disableSelectedCityWatch":true,"defaultLocation":true,"defaultCityId":"","defaultProvinceId":"","deliveryOptionStyle":"card","keyboardBox":false,"showTermsAcceptanceProp":false},...{}}' :style='""' class="my-5" >
                <template #default>default   </template>
                </m-un-authenticated-shopping-cart2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mModal501 from '@moeinmdn/miw-alpha-components/src/package/Tool/Modal/Modal501'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mUnAuthenticatedShoppingCart2 from '@moeinmdn/miw-alpha-components/src/package/UnAuthenticatedShoppingCart/UnAuthenticatedShoppingCart2';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mAlert1,mModal501,mP,mUnAuthenticatedShoppingCart2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
